module.exports = __webpack_public_path__ + "static/niegolewskich-img-7-90c6d9970864f8aa3ef9b59293538dd0.jpg";